import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

export default function RequireAdmin({ children }) {
  const { user, isAuthReady } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthReady) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role !== "admin") return <Navigate to="/konto" replace />;
  return children;
}
